<div class="card">
  <app-header
    titulo="Processos executados"
    descricao="Listagem dos processos solicitados"
  ></app-header>

  <app-listarprocessos processos="CONTRATOS"></app-listarprocessos>

</div>
